import { StyleSheet } from "react-native";
import React, { useEffect } from "react";
import { Text, View } from "../Themed";
import Colors from "../../constants/Colors";
import Animated, {
  Easing,
  SharedValue,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";

interface ProgressBarProps {
  step: number;
  totalSteps: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ step, totalSteps }) => {
  const offset = useSharedValue(0);

  useEffect(() => {
    offset.value = withTiming(step, {
      duration: 500,
      easing: Easing.inOut(Easing.ease),
    });
  });

  const barAnimatedStyle = useAnimatedStyle(() => {
    return {
      width: `${(offset.value / totalSteps) * 100}%`,
    };
  });

  return (
    <View>
      <View style={styles.background} />
      <Animated.View style={[styles.bar, barAnimatedStyle]} />
    </View>
  );
};

const styles = StyleSheet.create({
  background: {
    backgroundColor: Colors.nuetral_grey_100,
    borderColor: Colors.nuetral_grey_400,
    borderWidth: 1,
    borderRadius: 5,
    height: 10,
    width: "100%",
  },
  bar: {
    backgroundColor: Colors.primary_500,
    borderRadius: 5,
    height: 10,
    width: "50%",
    position: "absolute",
  },
});

export default ProgressBar;
